import type { RouteRecordRaw } from 'vue-router';

// B1 routes for the catalog feature. /:slug/ redirects straight to the
// catalog (browse-first). The bid CTA on the detail page opens a BidSheet overlay
// via ?bid=:id query. Each route is lazy-loaded so the feature's chunk
// forms its future parcel boundary. Event description + sponsors moved into
// EventAbout above the catalog grid.
export const routes: RouteRecordRaw[] = [
  {
    path: '/:slug/',
    redirect: (to) => ({ path: `/${to.params.slug}/items`, query: to.query, hash: to.hash }),
  },
  {
    path: '/:slug/items',
    name: 'catalog',
    component: () => import('./pages/CatalogPage.vue'),
    meta: { autoHideHeader: true },
  },
  {
    path: '/:slug/items/:id',
    name: 'item-detail',
    component: () => import('./pages/ItemDetailPage.vue'),
    meta: { hideBottomNav: true },
  },
  {
    path: '/:slug/bundles/:id',
    name: 'bundle-detail',
    component: () => import('./pages/BundleDetailPage.vue'),
    meta: { hideBottomNav: true },
  },
];
